import { OrderItem } from 'src/common/DeviceGrid/DeviceGrid.tsx';
import { MESSAGES } from 'src/modules/common/constants.ts';
import { FilterConfig } from 'src/utils/composeFilter.ts';
import { DirectionEnum } from 'src/generated/operations.ts';
import { DocumentNode, FieldNode, OperationDefinitionNode, SelectionNode } from 'graphql/language/ast';

export function generateOrderItems(names: string[], filterConfig: FilterConfig, direction: DirectionEnum): OrderItem[] {
    return filterConfig
        .filter(([name]) => names.includes(name))
        .map(([name, attrId]) => [MESSAGES[(name as keyof typeof MESSAGES)], attrId, direction]);
}

const collectFields = (selections: readonly SelectionNode[]): FilterConfig => {
    if (!Array.isArray(selections)) {
        return [];
    }
    return selections.reduce((acc, curr: FieldNode) => {
        const out = [...acc];
        if (curr.name && curr.alias && curr.kind === 'Field') {
            out.push([curr.alias.value, curr.name.value.replace('_', '')]);
        }
        const inner = collectFields(curr.selectionSet?.selections || []);
        return [...out, ...inner];
    }, [] as FilterConfig);
};

export const generateItemsConfig = (document: DocumentNode): FilterConfig => {
    const { definitions } = document;
    const [definition] = definitions as ReadonlyArray<OperationDefinitionNode>;
    const { selectionSet } = definition;
    return collectFields(selectionSet.selections);
};
